/* Navigator */
import * as navigator from "./navigator";

const utils = {
    navigator
}

export default utils;